// layouts/auth/index.js

import Footer from "components/footer/FooterAuthDefault";
import authImg from "assets/img/auth/auth.png";
import { Outlet } from "react-router-dom";

export default function Auth() {
  document.documentElement.dir = "ltr";
  document.body.classList.add("dark");

  return (
    <div className="min-h-screen w-full overflow-x-hidden bg-navy-900 text-white">
      <main className="relative flex min-h-screen w-full">

        {/* LEFT SIDE */}
        <div className="flex w-full flex-col justify-center px-5 py-10 md:px-10 lg:w-[52%] lg:px-16">

          <div className="mx-auto w-full max-w-[420px]">
            <Outlet />
          </div>

          <div className="mt-10">
            <Footer />
          </div>
        </div>

        {/* RIGHT IMAGE */}
        <div className="fixed right-0 top-0 hidden h-screen lg:block lg:w-[48%]">
          <div
            className="h-full w-full bg-cover bg-center rounded-bl-[120px]"
            style={{
              backgroundImage: `url(${authImg})`,
            }}
          />
        </div>

      </main>
    </div>
  );
}